import { ChfarExerciseSliceState } from "./slice";

export type ChfarExerciseState = {
  changeForAnyReason: {
    exercise: ChfarExerciseSliceState;
  };
};

export const selectChfarExerciseContractId = (state: ChfarExerciseState) =>
  state.changeForAnyReason.exercise.contractId;
